import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class StyleButton extends Component {
  constructor(props) {
    super(props);
    this.onToggle = (e) => {
      e.preventDefault();
      props.onToggle(props.style);
    };
  }

  render() {
    const { active, icon, label } = this.props;
    let className = 'entry-editor-styleButton';
    if (active) {
      className += ' entry-editor-activeButton';
    }

    return (
      <span className={className} onMouseDown={this.onToggle}>
        {icon ? <img className="fit-parent" src={icon} role="presentation" /> : label}
      </span>
    );
  }
}

StyleButton.propTypes = {
  active: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
  icon: PropTypes.string,
  style: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/cms/form/editor/StyleButton.js